var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"}},[_c('div',{ref:"marker",staticClass:"o-map-square-marker__content",class:'o-map-square-marker__content--' + this.color},[_c('o-icon',{staticClass:"o-map-square-marker__icon",attrs:{"name":_vm.iconName}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }